import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import { setCurrentProduct } from "../actions/products";
import { withProductRedirect } from './withProductRedirect';

/**
 * This container renders nothing, 
 * but is in charge of updating currently selected product globally.
 * 
 * Also handles storage of redirect URLs (?redirect=) from product
 * 
 * Usage: rendering <SetCurrentProduct product={productsById['aobox']} /> will set current product to aobox
 * 
 */

const mapStateToProps = ({currentProduct}) => ({
  currentProduct,
});

const mapDispatchToProps = (dispatch, {product, handleProductRedirect}) => ({
  onProductChange: () => {
    if( product ) {
      handleProductRedirect(product);
      dispatch( setCurrentProduct(product.id) );
    }
  },
});

class SetCurrentProduct extends React.Component {

  componentWillReceiveProps = ({
    product, 
    currentProduct, 
    onProductChange
  }) => {
    if ( product && (product.id !== currentProduct) ) {
      onProductChange();
    }
  }

  componentDidMount = () =>
    this.props.onProductChange();

  render = () => 
    null;
}

SetCurrentProduct.propTypes = {
  onProductChange: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  currentProduct: PropTypes.string,
}

export default withProductRedirect(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SetCurrentProduct)
)


// WEBPACK FOOTER //
// ./src/containers/SetCurrentProduct.js